import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import IUsersMixin from './IUserMixin'

@Component
export default class UsersMixin extends Vue implements IUsersMixin {
  public dialog: boolean = false
  public isPending: boolean = false

  @Prop(Function) private readonly getNbUser!: () => number

  public get hasSelectedUsers(): boolean {
    return this.getNbUser() > 0
  }

  public cancel() {
    this.isPending = false
    this.dialog = false
  }
}
